import { TableColumnMeta } from "ds/components/Table/types";

export const PLUGIN_TEMPLATES_COLUMNS_STORAGE_KEY = "plugin-templates-columns";
export enum PLUGIN_TEMPLATES_COLUMN_ID {
  NAME = "NAME",
  LABELS = "LABELS",
  DESCRIPTION = "DESCRIPTION",
  CREATED_AT = "CREATED_AT",
  DROPDOWN = "DROPDOWN",
}

export const PLUGIN_TEMPLATES_COLUMN_CONFIG: Record<PLUGIN_TEMPLATES_COLUMN_ID, TableColumnMeta> = {
  [PLUGIN_TEMPLATES_COLUMN_ID.NAME]: {
    id: PLUGIN_TEMPLATES_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 180,
    defaultWidth: 180,
    maxWidth: 2000,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [PLUGIN_TEMPLATES_COLUMN_ID.LABELS]: {
    id: PLUGIN_TEMPLATES_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 150,
    defaultWidth: 150,
    maxWidth: 2000,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [PLUGIN_TEMPLATES_COLUMN_ID.DESCRIPTION]: {
    id: PLUGIN_TEMPLATES_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 180,
    defaultWidth: 180,
    maxWidth: 2000,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [PLUGIN_TEMPLATES_COLUMN_ID.CREATED_AT]: {
    id: PLUGIN_TEMPLATES_COLUMN_ID.CREATED_AT,
    title: "Created At",
    minWidth: 160,
    defaultWidth: 160,
    maxWidth: 2000,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [PLUGIN_TEMPLATES_COLUMN_ID.DROPDOWN]: {
    id: PLUGIN_TEMPLATES_COLUMN_ID.DROPDOWN,
    title: "Template actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};
